<template>
	 <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="form quick-form" v-if="participant != null && venue != null">
        <div class="tabbed-selection package-tabs account-tabs">

                <div class="tabs-controller">
                    <a class="tab ignore" :class="{ active: current == 'FullWeek' }" @click="switchTab('FullWeek')" data-ChildSort="FullWeek">
                        Rookie Academy
                    </a>

                    <a class="tab ignore" :class="{ active: current == 'IndividualDays' }" @click="switchTab('IndividualDays')" data-ChildSort="IndividualDays">
                        {{ $root.config.use_short_weeks ? 'Customised Weeks' : 'Multi Active' }}
                    </a>
            </div>

            <div class="tabbed-panels account-panels quick-add">

                    <transition name="slide-fade">
                        <div class="panel-inner" v-if="current == 'FullWeek'" key="Full">
                            <div class="row">
                                <fullweek-form :bookingItem="bookingItem" :participant="participant" :venue="venue"></fullweek-form>
                            </div>
                        </div>

                        <div class="panel-inner" v-else-if="current == 'IndividualDays'" key="Individual">
                            <div class="row">
                                <shortweeks-form :bookingItem="bookingItem" :participant="participant" :venue="venue" v-if="$root.config.use_short_weeks"></shortweeks-form>
                                <individualdays-form :bookingItem="bookingItem" :participant="participant" :venue="venue" v-else></individualdays-form>
                            </div>
                        </div>

                        <div class="panel-inner" v-else key="Loading">
                            <div class="row">
                                <p class="text-center"><i class="fa fa-spinner fa-pulse fa-5x dark"></i></p>
                            </div>
                        </div>
                    </transition>
            </div>


        </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-else>
        <p class="text-center"><i class="fa fa-spinner fa-pulse fa-5x dark"></i></p>
    </div>
	</div>
</template>

<script>
    export default {
        data () {
            return {
                current: "FullWeek",
                participant: null,

                venue: null,
            }
        },
        computed: {
            bookingItem: function () {
                return {
                    venue_id: this.venue.id,
                    venue_name: this.venue.name,
                    venue_town: this.venue.town
                }
            },
            locale: function () {
                return this.$root.locale.basket.quick_add_edit;
            }
        },
        methods: {
            switchTab: function (tab) {
                this.current = tab;
            }
        },
        created () {
            /** Getting the participant **/
            axios.get('/camp-booking/participants/'+this.$route.params.childId)
                .then(response => {
                    this.participant = response.data.data;
                    $("html, body").animate({ scrollTop: $(".title-bar, .title-bar-top").offset().top }, "slow");

                    /**
                     * Setting the headers
                     **/
                    this.$root.headers = {
                        navigate: {
                            name: 'cart.basket',
                        },
                        breadcrumbs: [{to: {name: 'cart.basket'},title: this.participant.first_name + " " + this.participant.last_name}],
                        title: this.$root.locale.miscellaneous.page_headings.booking.quick_add,
                    }
                })

            /** Getting the current venue **/
            if(this.$route.params.hasOwnProperty('venueId'))
                axios.get('/camp-booking/venues/'+this.$route.params.venueId)
                    .then(response => {
                        this.venue = response.data.data;
                    })
        },
        components: {
            'fullweek-form': require('./FullWeek.vue'),
            'individualdays-form': require('./IndividualDays.vue'),
            'shortweeks-form': require('./ShortWeeks.vue'),
        }
    }
</script>



// WEBPACK FOOTER //
// QuickAdd.vue?ee19b520